import React from 'react'
import { ProgressRing } from 'components/Zui'

export const Loader = () => {
    return (
        <div
            style={{
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <ProgressRing size="s32"></ProgressRing>
        </div>
    )
}
